import React, { useRef, useState } from 'react';
import ariesImage from "../assets/zodiacimage/aries1.png";
import taurusImage from "../assets/zodiacimage/taurus1.png";
import geminiImage from "../assets/zodiacimage/gemini.png";
import cancerImage from "../assets/zodiacimage/cancer.png";
import leoImage from "../assets/zodiacimage/leo1.png";
import virgoImage from "../assets/zodiacimage/virgo.png";
import libraImage from "../assets/zodiacimage/libra.png";
import scorpioImage from "../assets/zodiacimage/scorpio.png";
import sagittariusImage from "../assets/zodiacimage/sagittarius.png";
import capricornImage from "../assets/zodiacimage/capricorn.png";
import aquariusImage from "../assets/zodiacimage/aquarius1.png";
import piscesImage from "../assets/zodiacimage/pisces.png";
import { FaChevronLeft, FaChevronRight, FaHome } from 'react-icons/fa';
import career from "../assets/extraimage/career.jpg";
import lover from "../assets/extraimage/lover.jpg";
import yesno from "../assets/extraimage/yesno.jpg";
import kundli from "../assets/extraimage/kundli.jpg";
import compatibility from "../assets/extraimage/compatibility.jpg";
import horoscope from "../assets/extraimage/horoscope.jpg";
import zodiachoroscope from "../assets/extraimage/zodiachoroscope.jpg";
import { Link, useNavigate } from 'react-router';
import work from "../assets/rootimg/career1.png";
import astrology from "../assets/tarotpageImage/astroimg.jpg"
import Queryform from './Queryform';
import Footer from '../home/Footer';
import Navbar from '../home/Navbar';
import { API_URL } from './Utils/Constant';
import BlogRecommendations from './AstroBlog/BlogRecommendations';


const WorkCompatibility = () => {
    const zodiacSigns = [
        { sign: 'Aries', image: ariesImage },
        { sign: 'Taurus', image: taurusImage },
        { sign: 'Gemini', image: geminiImage },
        { sign: 'Cancer', image: cancerImage },
        { sign: 'Leo', image: leoImage },
        { sign: 'Virgo', image: virgoImage },
        { sign: 'Libra', image: libraImage },
        { sign: 'Scorpio', image: scorpioImage },
        { sign: 'Sagittarius', image: sagittariusImage },
        { sign: 'Capricorn', image: capricornImage },
        { sign: 'Aquarius', image: aquariusImage },
        { sign: 'Pisces', image: piscesImage },
    ];

    const [yourSign, setYourSign] = useState('Aries');
    const [partnerSign, setPartnerSign] = useState('Leo');
    const [predictions, setPredictions] = useState(null);  // Track the predictions state
    const [isActive, setIsActive] = useState(false);  // Track if the form is active or not
    const getImageForSign = (sign) => {
        const zodiac = zodiacSigns.find((z) => z.sign === sign);
        return zodiac ? zodiac.image : null;
    };
    const reports = [
        { title: 'Love Tarot Reading', image: lover, link: '/love/tarot' },
        { title: 'Career Tarot', image: career, link: '/daily/tarot' },
        { title: 'Compatibility', image: compatibility, link: '/compatibility' },
        { title: 'Yes/No Reading', image: yesno, link: '/daily/tarot' },
        { title: 'Horoscope', image: horoscope, link: '/horoscope' },
        { title: 'Zodiac Horoscope', image: zodiachoroscope, link: '/horoscope' },
        { title: 'Free Kundli', image: kundli, link: '/new-kundli' }
    ];

    const navigate = useNavigate();
    const scrollContainer = useRef(null);

    const scrollLeft = () => {
        if (scrollContainer.current) {
            const scrollAmount = window.innerWidth < 768 ? 300 : 400;
            scrollContainer.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        if (scrollContainer.current) {
            const scrollAmount = window.innerWidth < 768 ? 300 : 400;
            scrollContainer.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };


    const handleReportClick = (link) => {
        navigate(link);
    };
    const handleButtonClick = async () => {
        const sign_pair = [`${yourSign} & ${partnerSign}`];

        try {
            // Send the selected signs to the backend API
            const response = await fetch(`${API_URL}compatibility/get-workpredictions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ sign_pair })
            });

            const data = await response.json();
           // console.log('Response from backend:', data);

            if (data && data.length > 0) {
                setPredictions(data[0].prediction);  // Save the prediction response
                setIsActive(true);  // Switch to the prediction view
            }
        } catch (error) {
            console.error('Error during API request:', error);
        }
    };

    return (
        <>
            <section className="bg-gradient-to-r from-white to-success/40  text-gray-900 min-h-screen">
                <Navbar />
                <div className="w-full max-w-3xl text-sm text-gray-600 flex flex-wrap justify-center sm:justify-start items-center mt-6 px-4 sm:px-8">
                    <Link to="/" className="text-secondary hover:underline">
                        HOME
                    </Link>
                    <FaChevronRight className="mx-2 text-gray-500" />

                    <Link to="/compatibility" className="text-secondary hover:underline">
                        COMPATIBILITY
                    </Link>
                    <FaChevronRight className="mx-2 text-gray-500" />

                    <span className="text-gray-700 font-semibold">WORK COMPATIBILITY</span>
                </div>
                {/* Conditional rendering */}
                {!isActive ? (
                    <div className="text-gray-900 p-6 sm:p-8 rounded-lg flex flex-col items-center py-8 md:py-12">
                        {/* Heading */}
                        <div className="flex flex-col sm:flex-row items-center text-center sm:text-left">
                            <img src={work} alt="bull.png" className="w-6 h-6 sm:w-8 sm:h-8 mr-2 mb-2 object-cover" />
                            <h1 className="text-2xl font-serif sm:text-3xl md:text-4xl font-bold text-secondary mb-2">
                                WORK COMPATIBILITY
                            </h1>
                        </div>
                        {/* Description */}
                        <p className="text-center text-secondary font-serif max-w-xl md:max-w-3xl mb-6 px-4 sm:px-0">
                            Curious if you and your team will thrive or face challenges? Discover the best ways to
                            collaborate and communicate with colleagues, bosses, and partners for a smoother working
                            relationship.
                        </p>
                        <h2 className="text-center text-lg font-serif sm:text-xl font-semibold mb-4">
                            Pick two zodiac signs to form your perfect match.
                        </h2>
                        {/* Zodiac Selection Section */}
                        <div className="flex flex-row gap-2 sm:flex-row md:flex-row justify-center items-center md:space-y-0 md:space-x-8">
                            {/* Your Sign Section */}
                            <div className="flex flex-col border-2 rounded-sm bg-gradient-to-r from-gray-50 to-gray-200/80 border-secondary p-5 sm:p-7 items-center">
                                <div className="w-24 h-24 sm:w-24 sm:h-24 lg:w-36 lg:h-36 md:w-36 md:h-36  rounded-full flex items-center justify-center mb-4">
                                    <img
                                        src={getImageForSign(yourSign)}
                                        alt={yourSign}
                                        className="w-full h-full object-contain ring-4 ring-secondary rounded-full"
                                    />
                                </div>
                                <span className="text-center font-semibold mb-2">Your Sign</span>
                                <select
                                    value={yourSign}
                                    onChange={(e) => setYourSign(e.target.value)}
                                    className="bg-secondary/20 text-gray-950 font-bold rounded-md px-4 sm:px-5 py-2 focus:ring-2 focus:ring-secondary"
                                >
                                    {zodiacSigns.map((zodiac) => (
                                        <option key={zodiac.sign} value={zodiac.sign}>
                                            {zodiac.sign}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="text-3xl sm:text-4xl font-bold">+</div>

                            {/* Partner's Sign Section */}
                            <div className="flex flex-col border-2 rounded-sm bg-gradient-to-r from-gray-50 to-gray-200/80 border-secondary p-5 sm:p-7 items-center">
                                <div className="w-24 h-24 sm:w-24 sm:h-24 lg:w-36 lg:h-36 md:w-36 md:h-36 rounded-full flex items-center border-2 border-secondary justify-center mb-4">
                                    <img
                                        src={getImageForSign(partnerSign)}
                                        alt={partnerSign}
                                        className="w-full h-full object-contain ring-4 ring-secondary rounded-full"
                                    />
                                </div>
                                <span className="text-center font-semibold mb-2">Partner's Sign</span>
                                <select
                                    value={partnerSign}
                                    onChange={(e) => setPartnerSign(e.target.value)}
                                    className="bg-secondary/20 text-gray-950 font-bold rounded-md px-4 sm:px-5 py-2 focus:ring-2  focus:ring-secondary"
                                >
                                    {zodiacSigns.map((zodiac) => (
                                        <option key={zodiac.sign} value={zodiac.sign}>
                                            {zodiac.sign}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Button Section */}
                        <div className="text-center mt-6">
                            <button
                                onClick={handleButtonClick}  // On click, send the request
                                className="bg-gray-900 transition duration-300 text-white py-2 px-16 sm:px-24 md:px-32 font-semibold rounded-md shadow hover:bg-success"
                            >
                                Get Your Career Compatibility
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="min-h-screen flex flex-col justify-center items-center py-12 px-4 sm:px-6 lg:px-8">
                        {/* Main Container */}
                        <div className="bg-white rounded-lg shadow-lg p-8 max-w-5xl w-full">
                            {/* Header Section */}
                            <h1 className="text-3xl font-bold text-center bg-gradient-to-r from-success to-[#9034E9] text-white p-2 rounded-md mb-8">
                                Work Compatibility for {yourSign} and {partnerSign}
                            </h1>

                            {/* Compatibility Content */}
                            <div className="flex sm:flex-row justify-center items-center mb-6">
                                {/* Your Sign */}
                                <div className="flex flex-col items-center mb-6 sm:mb-0 p-4">
                                    <h2 className="text-xl font-semibold text-secondary">Your Sign</h2>
                                    <div className="w-28 h-28 bg-gray-300 rounded-full flex items-center justify-center mb-4">
                                        <img src={getImageForSign(yourSign)} alt={yourSign} className="w-full h-full object-contain" />
                                    </div>
                                    <p className="text-lg text-white bg-secondary rounded-full px-4 py-1">{yourSign}</p>
                                </div>

                                {/* Plus Icon */}
                                <div className="mb-6 sm:mb-0">
                                    <h2 className="text-3xl font-semibold text-gray-800">+</h2>
                                </div>

                                {/* Partner's Sign */}
                                <div className="flex flex-col items-center mb-6 sm:mb-0 rounded-sm p-4">
                                    <h2 className="text-xl font-semibold text-secondary">Partner Sign</h2>
                                    <div className="w-28 h-28 bg-gray-300 rounded-full flex items-center justify-center mb-4">
                                        <img src={getImageForSign(partnerSign)} alt={partnerSign} className="w-full h-full object-contain" />
                                    </div>
                                    <p className="text-lg text-white bg-secondary rounded-full px-4 py-1">{partnerSign}</p>
                                </div>
                            </div>

                            {/* Description Section */}
                            <div className="text-gray-900 bg-slate-100 rounded-md p-3 text-justify mb-8">
                                <p className="mt-4 text-base">{predictions}</p>
                            </div>

                            {/* Button */}
                            <div className="flex justify-center">
                                <button onClick={() => setIsActive(false)} className="bg-gray-900 hover:bg-success tranistion duration-300 text-white font-bold py-2 px-20 rounded-full">
                                    Try Another Match
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Footer Section */}
                <div className="flex flex-col w-11/12 sm:w-4/5 mx-auto mt-8">
                    <hr className="border-secondary border-[1.5px] w-full mt-10" />
                    <p className="text-center mt-5 text-sm sm:text-base">
                        Discover your highest truth with the guidance of a gifted psychic reader.
                    </p>
                    <Link className="text-center text-sm sm:text-base font-semibold">Click here to claim your free reading!</Link>
                    <hr className="border-secondary border-[1.5px] w-full mt-5 mb-6" />
                </div>

                <main className="mt-4 px-4 sm:px-12 md:px-20 lg:px-44">
                    <div className="flex flex-col lg:flex-row gap-6 lg:gap-10">
                        {/* Work Compatibility Section */}
                        <div className="text-justify lg:w-2/3 mt-2">
                            <div className="text-gray-800 w-full rounded-lg">
                                <h2 className="text-2xl font-bold pt-3">About Work Compatibility</h2>
                                <p className="text-sm sm:text-base">
                                    Work compatibility in astrology explores how zodiac signs influence professional
                                    relationships, teamwork, and career success. By analyzing elements like Sun signs,
                                    Moon signs, and planetary alignments, astrology provides insights into communication
                                    styles, leadership qualities, and workplace dynamics. Fire signs (Aries, Leo, Sagittarius)
                                    thrive in leadership roles and fast-paced environments, while Earth signs (Taurus, Virgo,
                                    Capricorn) excel in structured, detail-oriented work. Air signs (Gemini, Libra, Aquarius)
                                    bring creativity and adaptability, and Water signs (Cancer, Scorpio, Pisces) offer emotional
                                    intelligence and intuition. Understanding astrological compatibility can help individuals
                                    choose the right career path, improve collaboration, and foster a harmonious work environment.
                                </p>

                                {/* Recommended Reports Section */}
                                <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
                                    <h2 className="text-lg sm:text-2xl font-bold pt-3 text-start mb-4">
                                        Recommended Reports For You
                                    </h2>
                                    <div className="flex space-x-2">
                                        <button onClick={scrollLeft} className="p-2">
                                            <FaChevronLeft className="text-gray-600 hover:text-gray-800" size={20} />
                                        </button>
                                        <button onClick={scrollRight} className="p-2">
                                            <FaChevronRight className="text-gray-600 hover:text-gray-800" size={20} />
                                        </button>
                                    </div>
                                </div>

                                {/* Scrollable Reports Section */}
                                <div className="flex items-center">
                                    <div
                                        ref={scrollContainer}
                                        className="flex overflow-x-hidden space-x-4 ml-2 scrollbar-hidden w-full snap-x snap-mandatory"
                                    >
                                        {reports.map((report, index) => (
                                            <div
                                                key={index}
                                                className="flex-shrink-0 w-48 p-4 bg-gray-200 rounded-lg shadow border-2 border-secondary hover:bg-secondary/35 snap-start"
                                                onClick={() => handleReportClick(report.link)}
                                            >
                                                <div className="w-full h-32 bg-gray-300 flex items-center justify-center rounded-md mb-2">
                                                    <img
                                                        src={report.image}
                                                        alt={report.title}
                                                        className="w-full h-full object-cover rounded-md cursor-pointer"
                                                    />
                                                </div>
                                                <h3 className="text-center font-semibold">{report.title}</h3>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Advisory Section */}
                        <div className="w-full lg:w-1/3">
                            <div className="bg-white mt-10 lg:mt-20 text-primary rounded-lg shadow-lg max-w-sm mx-auto">
                                <div className="flex justify-center">
                                    <img
                                        src={astrology}
                                        alt="Astrology placeholder"
                                        className="w-full h-48 bg-[#01010d] object-contain rounded-t-lg"
                                    />
                                </div>
                                <h2 className="text-3xl font-bold mt-2 text-center">AstroTellers</h2>
                                <div className="text-center">
                                    <p className="text-xl sm:text-2xl">Your Personalized</p>
                                    <p className="text-xl sm:text-2xl -mt-1">Cosmic Membership</p>
                                </div>
                                <p className="mx-4 text-center text-sm mt-2 mb-4">
                                    Daily, weekly, monthly, and yearly personalized astrological guidance at your fingertips.
                                </p>
                                <div className="text-center">
                                    <button 
                                    onClick={() => navigate('/comming-soon')}
                                    className="bg-primary text-white py-2 px-4 mb-4 rounded-lg hover:bg-success hover:shadow-xl transition duration-300">
                                        Join Astrology Plus
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <BlogRecommendations />
                <Queryform />
                <Footer />
            </section>

        </>
    );
};

export default WorkCompatibility;
